"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.creator.title': '帖子创建器',
    'socialMediaPlan.creator.subtitle': 'Brief → AI预览 → 计划',
    'socialMediaPlan.creator.selectPlatform': '请至少选择一个平台',
    'socialMediaPlan.creator.fillBrief': '请输入主题并选择平台',
    'socialMediaPlan.creator.aiError': 'AI生成失败。',
    'socialMediaPlan.creator.generate.title': '为每个平台生成内容',
    'socialMediaPlan.creator.generate.desc': '填写说明后生成。',
    'socialMediaPlan.creator.generateBtn': '使用AI生成',
    'socialMediaPlan.creator.generating': '生成中...',
    'socialMediaPlan.creator.manually': '手动编写',
    'socialMediaPlan.creator.regenerate': '重新生成',
    'socialMediaPlan.creator.caption': '标题',
    'socialMediaPlan.creator.imagePrompt': '图像提示',
    'socialMediaPlan.creator.imagePromptPlaceholder': '描述要生成的图像...',
    'socialMediaPlan.creator.generateImage': '生成图像',
    'socialMediaPlan.creator.imagePromptRequired': '请先输入提示',
    'socialMediaPlan.creator.imageError': '图像生成失败。',
    'socialMediaPlan.creator.videoUpload': '视频文件（YouTube / TikTok）',
    'socialMediaPlan.creator.videoUploadHint': 'YouTube 和 TikTok 必填。',
    'socialMediaPlan.creator.videoChoose': '选择视频文件',
    'socialMediaPlan.creator.imageSection': '图片',
    'socialMediaPlan.creator.imagePromptLabel': 'AI 生成',
    'socialMediaPlan.creator.imageUploadLabel': '或上传自己的图片',
    'socialMediaPlan.creator.imageChoose': '选择图片文件',
    'socialMediaPlan.creator.imageClear': '删除图片',
    'socialMediaPlan.creator.videoUploadOnNext': '点击“下一步”时将开始上传视频。',
    'socialMediaPlan.creator.videoReady': '视频已准备好，可以发布。',
    'socialMediaPlan.creator.videoError': '视频上传失败，请重试。',
    'socialMediaPlan.creator.tip2026Title': '2026 趋势提示',
    'socialMediaPlan.creator.tip2026Text': '简短、真实且行动号召明确的内容仍然能带来最高的互动。目前，轮播图和视频短片拥有最大的自然触达。',
    'socialMediaPlan.creator.brandName': '你的品牌',
    'socialMediaPlan.creator.now': '刚刚',
    'socialMediaPlan.creator.like': '赞',
    'socialMediaPlan.creator.comment': '评论',
    'socialMediaPlan.creator.share': '分享',
    'socialMediaPlan.creator.fbPageLabel': 'Facebook 主页',
    'socialMediaPlan.creator.fbNoPages': '未找到 Facebook 主页。请在设置中连接账户。',
    'socialMediaPlan.creator.liPageLabel': 'LinkedIn 主页',
    'socialMediaPlan.creator.ptBoardLabel': 'Pinterest 画板',
    'socialMediaPlan.creator.ptNoBoards': '未找到 Pinterest 画板。请在设置中连接账户。',
    'socialMediaPlan.creator.postContent': '帖子内容',
    'socialMediaPlan.creator.hashtags': '话题标签',
    'socialMediaPlan.creator.hashtagsHint': '用空格分隔',
    'socialMediaPlan.creator.aiInsightTitle': 'AI 洞察',
    'socialMediaPlan.creator.bestTime': '最佳时间：',
    'socialMediaPlan.creator.charLimit': '字符限制：',
    'socialMediaPlan.creator.videoRemove': '删除视频',
};
